<template>
	<div class="amount">
		<div class="title">Installment Plan</div>
		<div v-if="type == 1" class="install">
			<span class="money"><span v-text="fqAmount" /><i>MAX</i></span>
			<span class="nper">12 terms</span>
		</div>
		<div v-else class="install">
			<span class="money"><span v-text="userInfo.fqAmount || fqAmount" /><i>MAX</i></span>
			<span v-if="userInfo.status != 6" class="nper">12 terms</span>
		</div>
		<a @click="apply">Withdraw NOW</a>
		<p class="tips">Final amount will depend on eligibility</p>
	</div>
</template>

<script>
import NP from 'number-precision';
export default{
	props: ['type', 'data'],
    data(){
        return {
			pageType: this.type,  //1是未登录，2分期产品，3未进件，进件中
			userInfo: this.data,
			fqAmount: 60000
        }
    },

    methods:{
		apply(){
			let self = this;
			if(self.pageType == 1){
				self.UTILS.backLogin()
			}
			else if(self.pageType == 3){
				this.$emit("apply")
			}
			else{
				if(self.userInfo.status == 6){
					location.href = "./fqLoan.html";
				}else{
					location.href = "./infoGuidance.html?productType=DFEP&status="+ self.userInfo.status;
				}
			}
		}
    }
}
</script>
<style scoped>
.amount{ width: 6.8rem; height: 3.62rem; padding-top: 0.14rem; background: url(./img/icon9.png) no-repeat; background-size: cover; margin: -2.6rem auto 0 auto;}
.amount .title{ line-height: 0.66rem; text-align: center; font-size: 0.36rem; font-weight: bold; color:#fff;} 
.install{ height: 1.2rem; line-height: 1.2rem; text-align: center; color: #FFF; margin-top: 0.2rem;}
.money{ font-size: 1rem; text-shadow: 0 0.06rem 0.02rem #0237A1; position: relative;}
.money i{ line-height: 0.3rem; font-size: 0.24rem; font-style: normal; text-shadow: none; position: absolute; left: -0.4rem; top: 0;}
.nper{ font-size: 0.56rem; text-shadow: 0.01rem 0.01rem 0.06rem #0237A1; margin-left: 0.1rem;}
.amount a{width: 3rem; height: 0.8rem; line-height: 0.8rem; text-align: center; font-size: 0.3rem; font-weight: bold; color: #FFF; background: url(./img/icon10.png) no-repeat; background-size: cover; display: block; margin: 0.3rem auto 0 auto;}
.tips{margin-left: 2rem;color: #3D3D3D;text-align: right;margin-bottom: 0.12rem;transform: scale(0.7);}
</style>
